export default "__VITE_ASSET__tYhFOQe8__"